<div class="textbox-wrapper">
  <div class="zs-master-style text-field" [ngClass]="{ 'auto-suggest': autocompleteField && dataSource }">
    @if (!hideLabel) {
      <label class="text-field-label" [ngClass]="labelInverse ? 'zs-text-inverse': 'zs-text-headline'">
        @if (!showLabelTooltip) {
          <span>{{ hint }}</span>
        } @else {
          {{hint | applyEllipses:hintEllipsisConstant}}
          @if (hint.length > hintEllipsisConstant) {
            <zs-tooltip handle-transform class="tooltip-width">
              <zs-tooltip-content class="zs-size-xs tooltip-content">
                {{hint}}
              </zs-tooltip-content>
            </zs-tooltip>
          }
        }
        <!-- <span *ngIf="!required && enableSearch !== 'true' && showOptionalText" class="zs-font-weight-normal">
        <i translate> {{ commonlabels.OPTIONAL_IN_PARANTHESIS }} </i>
      </span> -->
      @if (infoLabel !== '') {
        <span id="info-icon" class="zs-icon zs-icon-info zs-size-l info-icon"></span>
      }
      @if (infoLabel !== '') {
        <zs-tooltip [handleTransform]="true" position="bottom-left" class="zs-size-s">
          {{infoLabel}}
        </zs-tooltip>
      }
    </label>
  }
  <p-is-zs-field #actionField [ngClass]="{ inputClass: true}" [ngStyle]="customStyle"
    class="zs-action-field zs-master-style icon field background-color-class" [type]="inputType" autocomplete="off"
    [icon]="enableSearch === 'true' ? 'search' : null" [clear]="enableSearch === 'true' ? '' : null"
    [value]="modelValue" [disabled]="disabled" (click)="onClick()" [placeholder]="placeholder"
    (focusout)="focusOutEvent($event)" (hint)="showHelperText()" [helperText]="helperText"
    [hintIcon]="infoIconMessage ? 'info' : null" [validationMessageText]="errorMessage"
  [validationMessageType]="errorClass" (input)="onTextChange($event.target.value)"></p-is-zs-field>

  @if (autocompleteField && dataSource) {
    <ul #menu class="zs-menu auto-suggest-menu" (changed)="menuOpened()"
      [ngStyle]="autoselectStyle">
      @if ({
        value:
        (dataSource | filterTable: [globalParamLabels.DISPLAY_LABEL]:this.searchText:false)
        }; as filterData) {
        @for (menu of filterData.value; track menu) {
          <li (mousedown)="selectValueFromMenu(menu)">
            <span>{{ final + menu.displayLabel }}</span>
          </li>
        }
      }
    </ul>
  }
</div>
</div>